import React from 'react'
import messages from './messages'
import { FormattedMessage } from 'react-intl'
import useLocale from 'js/hooks/useLocale'
import { GetPolicyLink } from '../../utils/getPolicyLink'

function Terms() {
  const { country, language } = useLocale()

  return (
    <span className="py-[10px] text-left text-TypeSub">
      <FormattedMessage
        {...messages.policyAgreement}
        values={{
          a: function Anchor(...chunks) {
            return (
              <a
                href={GetPolicyLink(country, language)}
                rel="noopener noreferrer"
                target="_blank"
                className=" text-LSBrand underline underline-offset-4"
              >
                {chunks}
              </a>
            )
          },
        }}
      />
    </span>
  )
}

export default Terms
